import { FiscalYearStatusCode } from "@odata/GeneratedEnums";
import { withOData } from "@odata/withOData";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

import ParentChildPage, { IParentPageProps } from "../ParentChildPage";
import { getDefinitions } from "./ChartOfAccountsDef";
import ChartOfAccountsTableView from "./ChartOfAccountsTableView";

class ChartOfAccounts extends ParentChildPage<IParentPageProps> {
    static defaultProps = {
        tableView: ChartOfAccountsTableView,
        getDef: getDefinitions
    };

    get defaultParentKey(): string {
        return this.parents.find(parent => parent.FiscalYear.StatusCode === FiscalYearStatusCode.Active)?.Id ?? this.parents?.[0]?.Id?.toString() ?? "";
    }
}

export default withRouter(withTranslation(getDefinitions.translationFiles)(withOData(ChartOfAccounts)));
